<template>
  <div class="h-100vh pt-50 pb-50">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="pingo-form ms-auto me-auto">
          <div class="title">
            <div class="d-flex justify-center align-items-center mb-10">
              <v-img src="@/assets/img/logo.svg" alt="logo" width="100" />
            </div>
          </div>

          <form @submit.prevent="handleSubmit()">
            <div class="bg-white border-radius p-20">
              <div class="pingo-form-group without-icon mb-0">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Email <span>*</span>
                </label>

                <TextInput
                  :label="'Digite o seu email'"
                  :type="'email'"
                  v-model="signInForm.email"
                  :error-messages="
                    v$.email.$errors ? v$.email.$errors[0]?.$message : undefined
                  "
                />
              </div>

              <div class="pingo-form-group without-icon mb-0">
                <label class="d-block mb-12 fw-semibold gray-color">
                  Senha
                  <span>*</span>
                </label>

                <TextInput
                  :label="'Digite a sua senha'"
                  :type="'password'"
                  v-model="signInForm.password"
                  :error-messages="
                    v$.password.$errors
                      ? v$.password.$errors[0]?.$message
                      : undefined
                  "
                />
              </div>
            </div>

            <!-- <div class="d-flex align-center justify-center mt-4 ga-2">
              <p class="mb-0">Não tem uma conta?</p>
              <router-link
                to="/autenticar/criar-conta"
                class="d-inline-block main-color w-auto fw-medium"
              >
                Crie uma aqui!
              </router-link>
            </div> -->

            <div class="d-flex info align-center justify-space-between">
              <v-checkbox
                class="gray-color"
                hide-details
                color="info"
                v-model="signInForm.remember"
                label="Lembrar deste acesso"
              >
              </v-checkbox>

              <router-link
                to="/autenticar/esqueci-minha-senha"
                class="d-inline-block main-color w-auto fw-medium"
              >
                Esqueceu a sua senha?
              </router-link>
            </div>

            <PrimaryButton
              class="mt-0"
              :is-loading="isLoading"
              label="Entrar"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";

import { useRouter } from "vue-router";

import { useVuelidate } from "@vuelidate/core";

import { useAuth } from "@/composables/useAuth";

import PrimaryButton from "@/components/Forms/BasicElements/Button/PrimaryButton.vue";

import TextInput from "@/components/Forms/BasicElements/Input/TextInput.vue";

export default defineComponent({
  name: "SignInPage",
  components: {
    TextInput,
    PrimaryButton,
  },
  setup() {
    const router = useRouter();

    const { signInFormRules, signInForm, autoSignIn, signIn, isLoading } =
      useAuth();

    const handleSubmit = async () => {
      try {
        const result = await v$.value.$validate();

        if (!result) return;

        const response = await signIn(signInForm.email, signInForm.password);

        if (response) {
          router.push({ name: "DashboardPage" }).then(() => {
            router.go(0);
          });
        }
      } catch (e) {
        console.error(e);
      }
    };

    onMounted(async () => {
      const response = await autoSignIn();
      if (response) {
        router.push({ name: "DashboardPage" }).then(() => {
          router.go(0);
        });
      }
    });

    const v$ = useVuelidate(signInFormRules, signInForm);

    return {
      signInForm,
      isLoading,
      handleSubmit,
      v$,
    };
  },
});
</script>

<style lang="scss" scoped>
.v-selection-control {
  .v-label {
    white-space: nowrap !important;
  }
}

button,
a {
  border-radius: 5px !important;

  &.w-auto {
    width: auto !important;
  }

  &.success {
    background-color: var(--heraBlueColor);
    color: var(--whiteColor);
  }

  &.gray {
    background-color: #edeff5;
    color: var(--blackColor);
  }

  font: {
    weight: 600 !important;
    size: 14px !important;
  }
}

.pingo-form {
  max-width: 510px;

  .title {
    margin-bottom: 30px;

    p {
      font-size: 18px;

      a {
        font-size: 18px !important;
      }
    }
  }

  .login-with-socials {
    margin-bottom: 25px;

    button {
      margin-top: 0;
      font-size: 15px !important;
      padding: 17px 25px 17px 60px !important;
      position: relative;
      border-radius: 5px !important;
      width: 100%;

      .v-img {
        top: 52%;
        position: absolute;
        transform: translateY(-52%);

        margin: {
          left: -25px;
        }
      }

      &.gray {
        border: 1px solid #edeff5 !important;
        background-color: var(--whiteColor) !important;
      }

      &.success {
        background-color: var(--heraBlueColor);
        color: var(--whiteColor);
      }
    }
  }

  .or {
    margin-bottom: 25px;
    color: #777e90;
    line-height: 1;
    z-index: 1;

    span {
      display: inline-block;
      background: #f5f5f5;

      padding: {
        left: 15px;
        right: 15px;
      }
    }

    &::before {
      left: 0;
      right: 0;
      top: 50%;
      height: 1px;
      content: "";
      z-index: -1;
      position: absolute;
      background: #e2e8f0;
      transform: translateY(-50%);
    }
  }

  button {
    margin-top: 15px;
    padding: 17px 35px !important;
    width: 100%;

    font: {
      size: 18px !important;
      family: var(--headingFontFamily) !important;
    }
  }

  .info {
    margin-top: 15px;

    a {
      &:hover {
        color: var(--blackColor) !important;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .pingo-form {
    max-width: 100%;

    padding: {
      left: 15px;
      right: 15px;
    }

    .title {
      margin-bottom: 20px;

      p {
        font-size: 15px;
      }
    }

    .login-with-socials {
      margin-bottom: 20px;

      button {
        margin-bottom: 15px;
      }
    }

    .or {
      margin-bottom: 20px;
    }

    button {
      margin-top: 15px;
      font-size: 15px !important;
      padding: 17px 30px !important;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .pingo-form {
    .title {
      margin-bottom: 15px;

      p {
        font-size: 15px;
      }
    }

    .login-with-socials {
      margin-bottom: 20px;
    }

    .or {
      margin-bottom: 20px;
    }

    button {
      margin-top: 15px;
      font-size: 16px !important;
    }
  }
}
</style>
